import { PageBreadcrumbs } from "@/shared/components";

import { useEphemeralWorkspaceState } from "../../WorkspaceCtx/hooks";

import { DatasetInfo } from "./DatasetInfo";
import { FileInfo } from "./FileInfo";

export function DatasourceInfo() {
  const { isDataLoading, files } = useEphemeralWorkspaceState();

  const datasetIds = [
    ...new Set<string>(
      files.map((f) => f.association_id).filter((id) => id !== undefined),
    ),
  ];

  return (
    <PageBreadcrumbs>
      <DatasetInfo isDatasetsLoading={isDataLoading} datasetIds={datasetIds} />
      <FileInfo isFilesLoading={isDataLoading} files={files} />
    </PageBreadcrumbs>
  );
}
